<template>
    <div>
        <div v-if="isCustomer">
            <customer-account-info :customer="customerUserData"></customer-account-info>
            <customer-account-change-password></customer-account-change-password>
        </div>
        <div v-else-if="isCompany">
            <company-account-request-answers></company-account-request-answers>
            <company-account-info :userData="companyUserData" :companyData="companyData"></company-account-info>
            <company-account-change-password></company-account-change-password>
            <company-account-mail-routine></company-account-mail-routine>
            <company-account-active-services v-if="companyUserData.Services.length > 0" :companyServices="companyUserData.Services"></company-account-active-services>
        </div>
    </div>
</template>
<script>
    import CustomerAccountInfo from '../components/organisms/my-pages-sections/customer/account/OrganismMyPagesAccountInfo.vue';
    import CustomerAccountChangePassword from '../components/organisms/my-pages-sections/customer/account/OrganismMyPagesAccountPassword.vue';

    import CompanyAccountInfo from '../components/organisms/my-pages-sections/company/account/OrganismMyPagesAccountInfo.vue';
    import CompanyAccountChangePassword from '../components/organisms/my-pages-sections/company/account/OrganismMyPagesAccountPassword.vue';
    import CompanyAccountMailRoutine from '../components/organisms/my-pages-sections/company/account/OrganismMyPagesAccountMailRoutine.vue'
    import CompanyAccountActiveServices from '../components/organisms/my-pages-sections/company/account/OrganismMyPagesAccountServices.vue'
    import CompanyAccountRequestAnswers from '../components/organisms/my-pages-sections/company/account/OrganismMyPageResponses.vue';

    export default {
        props: [
            'isCustomer',
            'isCompany',
            'companyUserData',
            'companyData',
            'customerUserData'
        ],
        components: {
            CompanyAccountRequestAnswers,
            CustomerAccountInfo,
            CustomerAccountChangePassword,
            CompanyAccountInfo,
            CompanyAccountChangePassword,
            CompanyAccountMailRoutine,
            CompanyAccountActiveServices,
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/my-pages-sublayouts/MyPagesAccount.vue